import React from 'react'
import UpdateProfilePhoto from 'src/app/UpdateProfilePhoto/UpdateProfilePhoto'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateProfilePhotoRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateProfilePhotoAppRoute: AppRoute = {
  id: AppLocation.UpdateProfilePhoto,
  routeProps: updateProfilePhotoRouteProps,
  component: <UpdateProfilePhoto />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateProfilePhotoAppRoute
